import React from 'react';
import { Marquee } from './ui/magic/Marquee';

const supporters = [
  { name: 'Microsoft for Startups', logo: '/images/microsoft.png', height: 36 },
  { name: 'NVIDIA Inception Program', logo: '/supporters/nvidia.png', height: 44 },
  { name: 'Amazon', logo: '/supporters/Amazon_logo.svg.png', height: 30 },
];

const professionals = [
  { name: 'Stanford Medicine', logo: '/supporters/stanford.png', height: 44 },
  { name: 'Keck Medicine of USC', logo: '/supporters/usc.png', height: 48 },
  { name: 'U.S. Department of Veterans Affairs', logo: '/supporters/us.png', height: 64 },
];

const Logo: React.FC<{ item: { name: string; logo: string; height: number } }> = ({ item }) => (
  <img
    src={item.logo}
    alt={item.name}
    style={{ height: item.height }}
    className="w-auto object-contain"
    loading="lazy"
  />
);

export const TrustedBySection: React.FC = () => {
  return (
    <section className="py-8 bg-white border-b border-slate-100 relative">
      {/* Full height vertical lines at container edges */}
      <div className="absolute inset-0 max-w-7xl mx-auto pointer-events-none">
        <div className="absolute left-0 top-0 bottom-0 w-px bg-slate-200"></div>
        <div className="absolute right-0 top-0 bottom-0 w-px bg-slate-200"></div>
      </div>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative">

        {/* Desktop: grouped layout */}
        <div className="hidden md:flex flex-row items-center justify-center gap-24 opacity-70 grayscale hover:grayscale-0 transition-all duration-500">

          {/* Supporters */}
          <div className="flex flex-col items-center gap-6">
            <span className="text-xs font-semibold tracking-wider text-slate-400 uppercase">Funded By</span>
            <div className="flex items-center gap-12">
              {supporters.map((item) => (
                <Logo key={item.name} item={item} />
              ))}
            </div>
          </div>

          {/* Divider */}
          <div className="w-px h-16 bg-slate-200" />

          {/* Professionals */}
          <div className="flex flex-col items-center gap-6">
            <span className="text-xs font-semibold tracking-wider text-slate-400 uppercase">Recognized By Professionals From</span>
            <div className="flex items-center gap-12">
              {professionals.map((item) => (
                <Logo key={item.name} item={item} />
              ))}
            </div>
          </div>

        </div>

        {/* Mobile: marquee */}
        <div className="md:hidden flex flex-col items-center gap-6">
          <span className="text-xs font-semibold tracking-wider text-slate-400 uppercase text-center">
            Funded By &amp; Recognized By Professionals From
          </span>
          <Marquee pauseOnHover className="[--duration:25s] [--gap:3.5rem] mask-linear-fade opacity-70 grayscale">
            {[...supporters, ...professionals].map((item) => (
              <Logo key={item.name} item={item} />
            ))}
          </Marquee>
        </div>

      </div>
    </section>
  );
};
